import { types, destroy, getParent } from 'mobx-state-tree'
import { values } from 'mobx'
import shortid from 'shortid'
import { CustomerReference } from './Customer'
import { Part } from './Part'
import { Operation } from './Operation'
import { OtherCost } from './OtherCost'
import Estimate from './Estimate'
import { format } from 'date-fns';
import { rootStore } from '../index';

export const JobReference = types.reference(types.late(() => Job), {
  get(id, parent) {
    // const rootStore = getParent(parent, 2)
    const job = values(rootStore.jobs).find(j => j.id === id)
    if (!job) {
      rootStore.loadJob(id)
      return { id: id, description: 'Loading...' }
    }
    return job
  },
  set(value) {
    return value.id
  }
})

const Job = types
  .model({
    id: types.identifier(types.string),
    jobNumber: types.maybe(types.string),
    description: '',
    finish: '',
    comment: '',
    usualCustomer: types.maybe(CustomerReference),
    parts: types.optional(types.array(types.late(() => Part)), []),
    labour: types.optional(types.array(types.late(() => Operation)), []),
    otherCosts: types.optional(types.array(types.late(() => OtherCost)), []),
    estimates: types.optional(types.array(types.late(() => Estimate)), []),
    dateCreated: types.maybe(types.Date),
  })
  .preProcessSnapshot(snapshot => {
    const copy = Object.assign(snapshot)
    if (!copy.id) copy.id = shortid.generate()
    return copy
  })
  .actions(self => ({
    save() {
      console.log('Saving job', self.id)
      const rootStore = getParent(self, 2)
      if (rootStore) {
        rootStore.saveItem(self)
      }
      // store.setItem(self.id, getSnapshot(self))
    },
    afterAttach() {
      // console.log('afterAttach')
      if (!self.dateCreated) {
        self.dateCreated = new Date()
      }
      // onSnapshot(self, snapshot => {
      //   console.log(snapshot)
      //   self.save()
        // self.dateUpdated = new Date()
      // })
    },
    setJobNumber(newJobNumber) {
      self.jobNumber = newJobNumber
    },
    setDescription(newDescription) {
      self.description = newDescription
    },
    setFinish(string) {
      self.finish = string
    },
    setComment(string) {
      self.comment = string
    },
    setUsualCustomer(customer) {
      if (customer === '') {
        self.usualCustomer = null
      } else {
        self.usualCustomer = customer
      }
      // if (hasParent(self)) self.save()
    },
    addPart(part) {
      self.parts.push(part)
    },
    addLabour(model) {
      self.labour.push(model)
    },
    addOtherCost(cost) {
      self.otherCosts.push(cost)
    },
    addEstimate(snapshot) {
      const e = Estimate.create(snapshot)
      self.estimates.push(e)
      e.recalculateAll()
    },
    removeItem(item) {
      destroy(item)
    },
    recalculateMaterialsForAllEstimates() {
      self.estimates.forEach(e => {
        e.recalculateBom()
      })
    },
    recalculateOtherCostsForAllEstimates() {
      self.estimates.forEach(e => {
        e.recalculateAdditionalCosts()
      })
    },
  })).views(self => ({
    get isValid() {
      return self.description.length > 0
    },
    get asString() {
      return self.jobNumber ? self.jobNumber + ' - ' + self.description : self.description
    },
    get usualCustomerAsString() {
      return self.usualCustomer ? self.usualCustomer.name : ''
    },
    get dateCreatedAsString () {
      return self.dateCreated ? format(self.dateCreated, 'DD/MM/YY') : ''
    },
    get hasEstimates() {
      return self.estimates.length > 0
    },
    qtyExists(qty) {
      const qtys = self.estimates.map(e => e.qty)
      return qtys.includes(qty)
    },
    findEstimate(qty) {
      return self.estimates.find(e => e.qty === qty)
    }
  }))

  export default Job;



// WEBPACK FOOTER //
// ./src/models/Job.js